var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMexc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#151617"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2378 15.2426L25.3688 1.80805C23.9448 -0.590966 20.46 -0.590966 19.0361 1.80805L11.167 15.2426C9.74308 17.6416 11.5043 20.6311 14.3521 20.6311H30.0902C32.9006 20.6311 34.6243 17.6416 33.2378 15.2426Z",
    fill: "#00B897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7455 15.5019L22.2958 14.7268C21.8837 13.9887 20.9469 12.4385 20.9469 12.4385L14.6891 1.80903C13.2652 -0.58999 9.7803 -0.58999 8.35637 1.80903L0.487319 15.2435C-0.936605 17.6426 0.824565 20.6321 3.67241 20.6321H19.2606H25.7432H30.09C26.1929 20.6321 24.5441 18.5653 22.7455 15.5019Z",
    fill: "#76FCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7458 15.5011L22.2961 14.726C21.8839 13.9879 20.9471 12.4377 20.9471 12.4377L16.8627 5.49902L11.167 15.2427C9.74308 17.6418 11.5043 20.6313 14.3521 20.6313H19.2609H25.7435H30.0902C26.1932 20.6313 24.5444 18.5645 22.7458 15.5011Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.02535,
    y1: 10.8255,
    x2: 27.1321,
    y2: 17.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53E57A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A977"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexc);
export default __webpack_public_path__ + "static/media/mexc.95915bdb56d31d2d87751dce7e83ebdd.svg";
export { ForwardRef as ReactComponent };